import { AlertTriangle, CheckCircle2, XCircle, Info } from "lucide-react";
import { Modal } from "./Modal";

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  type?: "danger" | "success" | "warning" | "info";
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
}

export function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  type = "danger",
  confirmText = "Confirmer",
  cancelText = "Annuler",
  loading = false,
}: ConfirmModalProps) {
  const handleConfirm = () => {
    onConfirm();
  };

  const typeStyles = {
    danger: {
      icon: XCircle,
      iconColor: "text-red-600",
      buttonColor: "bg-red-600 hover:bg-red-700",
    },
    success: {
      icon: CheckCircle2,
      iconColor: "text-green-600",
      buttonColor: "bg-green-600 hover:bg-green-700",
    },
    warning: {
      icon: AlertTriangle,
      iconColor: "text-yellow-600",
      buttonColor: "bg-yellow-600 hover:bg-yellow-700",
    },
    info: {
      icon: Info,
      iconColor: "text-blue-600",
      buttonColor: "bg-blue-600 hover:bg-blue-700",
    },
  };

  const style = typeStyles[type];
  const Icon = style.icon;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="space-y-4">
        <div className="flex items-start gap-4">
          <Icon className={`w-6 h-6 ${style.iconColor} flex-shrink-0 mt-0.5`} />
          <p className="text-gray-700 flex-1">{message}</p>
        </div>
        <div className="flex flex-col-reverse sm:flex-row gap-2 sm:justify-end pt-4 border-t">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed min-h-[44px] font-medium"
          >
            {cancelText}
          </button>
          <button
            onClick={handleConfirm}
            disabled={loading}
            className={`px-4 py-2 text-white rounded disabled:opacity-50 disabled:cursor-not-allowed min-h-[44px] font-medium ${style.buttonColor}`}
          >
            {loading ? "Traitement..." : confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
}

